
(function(){
  'use strict';
  var inEditor = (window.Shopify && Shopify.designMode);
  var $=function(s,c){return (c||document).querySelector(s);};
  var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};

  /* ---------- mobile menu ---------- */
  function wireMenu(root){
    root=root||document;
    var burger=$('#burger',root)||$('.nav__burger',root), mm=$('#mobileMenu');
    if(burger&&mm&&!burger.__w){burger.__w=1;burger.addEventListener('click',function(){mm.classList.toggle('open');});}
    if(mm&&!mm.__w){mm.__w=1;$$('a',mm).forEach(function(a){a.addEventListener('click',function(){mm.classList.remove('open');});});}
  }

  /* ---------- nav scroll state ---------- */
  var nav=$('#nav');
  if(nav){addEventListener('scroll',function(){nav.classList.toggle('scrolled',scrollY>60);},{passive:true});}

  /* ---------- reveal on scroll (editor-safe) ---------- */
  function initReveals(scope){
    scope=scope||document;
    var els=$$('.reveal',scope);
    if(inEditor){els.forEach(function(e){e.classList.add('in');});return;}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.12});
    els.forEach(function(el){if(!el.classList.contains('in'))io.observe(el);});
  }

  /* ---------- count ups ---------- */
  function initCounts(scope){
    scope=scope||document;
    $$('[data-count]',scope).forEach(function(el){
      if(el.__c)return;el.__c=1;
      var t=+el.dataset.count,suf=el.dataset.suf||'';
      if(inEditor){el.textContent=t+suf;return;}
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){var s=null,d=1400;
        function step(ts){if(!s)s=ts;var p=Math.min((ts-s)/d,1);el.textContent=Math.floor(p*t)+suf;if(p<1)requestAnimationFrame(step);}requestAnimationFrame(step);io.unobserve(el);}});},{threshold:.6});
      io.observe(el);
    });
  }

  /* ---------- the 92 sunburst ---------- */
  function initSun(scope){
    scope=scope||document;
    var rays=$$('.ray',scope);if(!rays.length)return;
    var rn=$('#mName',scope),rf=$('#mFn',scope),counter=$('#sunCount',scope),lit=new Set();
    function up(g){var nm=g.dataset.name;lit.add(nm);g.classList.add('active');
      if(rn)rn.textContent=g.dataset.name;if(rf)rf.textContent=g.dataset.fn;
      if(counter){var val=Math.min(92,Math.round(92*(lit.size/rays.length)));counter.textContent=Math.max(val,lit.size);}}
    rays.forEach(function(g){if(g.__s)return;g.__s=1;g.addEventListener('mouseenter',function(){up(g);});g.addEventListener('click',function(){up(g);});});
  }

  /* ---------- parallax bg image ---------- */
  function initParallax(scope){
    scope=scope||document;
    $$('[data-parallax-img]',scope).forEach(function(el){
      var d=el.getAttribute('data-parallax-img'),m=el.getAttribute('data-parallax-mobile')||d;
      el.style.backgroundImage="url('"+(innerWidth<=860?m:d)+"')";
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq(scope){
    scope=scope||document;
    $$('.faq__q',scope).forEach(function(b){if(b.__f)return;b.__f=1;b.addEventListener('click',function(){
      var it=b.parentElement,a=it.querySelector('.faq__a');var open=it.classList.contains('open');
      it.classList.toggle('open');a.style.maxHeight=open?null:(a.scrollHeight+'px');});});
  }

  /* ---------- PDP gallery + qty + variant ---------- */
  function initPdp(scope){
    scope=scope||document;
    var main=$('#galMain',scope),thumbs=$('#galThumbs',scope);
    if(thumbs&&!thumbs.__g){thumbs.__g=1;thumbs.addEventListener('click',function(e){var t=e.target.closest('.t');if(!t)return;
      $$('.t',thumbs).forEach(function(x){x.classList.remove('active');});t.classList.add('active');
      if(main){var img=main.querySelector('img');if(img)img.src=t.getAttribute('data-src');}});}
    var q=$('#qVal',scope);
    var minus=$('#qMinus',scope),plus=$('#qPlus',scope);
    if(minus&&!minus.__q){minus.__q=1;minus.addEventListener('click',function(){var v=+q.textContent;if(v>1){q.textContent=v-1;}});}
    if(plus&&!plus.__q){plus.__q=1;plus.addEventListener('click',function(){q.textContent=(+q.textContent)+1;});}
    // variant select / pack buttons -> update hidden id + price; smoothie/bundle behavior
    var form=$('[data-product-form]',scope);
    if(form&&!form.__v){form.__v=1;
      var kind=form.getAttribute('data-pdp-kind')||'standard';
      var sel=$$('[data-variant-opt]',form);
      var packBtns=$$('[data-pack-btn]',form);
      var idField=$('[name="id"]',form),priceEl=$('#buyPriceVal',scope);
      var qtyWrap=$('#qtyWrap',scope);
      var variants=[];try{variants=JSON.parse($('[data-variants]',scope).textContent);}catch(e){}
      function money(c){return '$'+(c/100).toFixed(2);}
      function packCount(){ // leading integer of the chosen pack value ("1 for $10" -> 1, "3 pouches — $26" -> 3)
        var act=packBtns.filter(function(b){return b.classList.contains('active');})[0];
        var val=act?act.getAttribute('data-value'):'';
        var m=(val||'').match(/\d+/);return m?parseInt(m[0],10):1;
      }
      function chosenValues(){
        if(packBtns.length){var a=packBtns.filter(function(b){return b.classList.contains('active');})[0];return [a?a.getAttribute('data-value'):''];}
        return sel.map(function(s){return s.value;});
      }
      function pick(){
        var chosen=chosenValues();
        var v=variants.filter(function(x){return x.options.join(' / ')===chosen.join(' / ');})[0]||variants[0];
        if(v){idField.value=v.id;if(priceEl)priceEl.textContent=money(v.price);}
        applyQtyMode();
      }
      function applyQtyMode(){
        if(!qtyWrap)return;
        if(kind==='bundle'){qtyWrap.style.display='none';if(q)q.textContent='1';}
        else if(kind==='smoothie'){var c=packCount();if(c===1){qtyWrap.style.display='';}else{qtyWrap.style.display='none';if(q)q.textContent='1';}}
        else{qtyWrap.style.display='';}
        if(kind==='bundle')syncBundle();
      }
      sel.forEach(function(s){s.addEventListener('change',pick);});
      packBtns.forEach(function(b){b.addEventListener('click',function(){
        packBtns.forEach(function(x){x.classList.remove('active');x.setAttribute('aria-pressed','false');});
        b.classList.add('active');b.setAttribute('aria-pressed','true');pick();
      });});
      /* ---- BYO bundle flavor counters ---- */
      var bundleWrap=$('[data-bundle-flavors]',form);
      function syncBundle(){
        if(!bundleWrap)return;
        var need=packCount();
        var rows=$$('.flavrow',bundleWrap);
        var total=rows.reduce(function(s,r){return s+(+$('[data-fval]',r).textContent);},0);
        var cnt=$('[data-bundle-count]',bundleWrap);if(cnt)cnt.textContent=total+' of '+need;
        rows.forEach(function(r){var inc=$('[data-finc]',r);if(inc)inc.disabled=(total>=need);});
        var addBtn=$('.buy__add',form);
        var ok=(total===need);
        if(addBtn){addBtn.disabled=!ok;addBtn.classList.toggle('is-locked',!ok);}
        var hint=$('[data-bundle-hint]',bundleWrap);
        if(hint)hint.textContent= ok ? 'Looks good — '+need+' pouches selected.' : 'Choose '+(need-total)+' more pouch'+((need-total)===1?'':'es')+' (any mix of flavors).';
      }
      if(bundleWrap&&!bundleWrap.__b){bundleWrap.__b=1;
        bundleWrap.addEventListener('click',function(e){var t=e.target;
          var r=t.closest('.flavrow');if(!r)return;var span=$('[data-fval]',r);var v=+span.textContent;
          if(t.hasAttribute('data-finc')){if(!t.disabled)span.textContent=v+1;}
          else if(t.hasAttribute('data-fdec')){span.textContent=Math.max(0,v-1);}
          syncBundle();
        });
      }
      pick();
    }
  }

  /* ---------- SEARCH overlay (predictive) ---------- */
  function initSearch(){
    var btn=$('#searchBtn'),ov=$('#searchOv'),inp=$('#searchInput'),res=$('#searchRes'),cls=$('#searchClose'),mm=$('#mmSearch');
    if(!ov||ov.__s)return;ov.__s=1;
    function open(){ov.classList.add('open');setTimeout(function(){if(inp)inp.focus();},150);render('');}
    function close(){ov.classList.remove('open');}
    // suggest.json returns price as a decimal string in the store currency ("32.00"),
    // not cents. Format defensively for strings (dollars), pre-formatted money, or cents numbers.
    function fmtSuggestPrice(v){
      if(v==null||v==='')return '';
      if(typeof v==='number'){return '$'+(v/100).toFixed(2);}      // cents integer
      var s=String(v).trim();
      if(/[^\d.,]/.test(s))return s;                                 // already has a currency symbol
      var n=parseFloat(s.replace(/,/g,''));
      if(isNaN(n))return '';
      return '$'+n.toFixed(2);                                       // decimal string = dollars
    }
    var timer;
    function render(q){
      q=(q||'').trim();
      if(!q){res.innerHTML='<div class="none">Start typing to search products…</div>';return;}
      res.innerHTML='<div class="none">Searching…</div>';
      clearTimeout(timer);timer=setTimeout(function(){
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=8')
        .then(function(r){return r.json();}).then(function(d){
          var items=(d.resources&&d.resources.results&&d.resources.results.products)||[];
          if(!items.length){res.innerHTML='<div class="none">No products match “'+q+'”.</div>';return;}
          res.innerHTML=items.map(function(p){var pr=fmtSuggestPrice(p.price);return '<a href="'+p.url+'">'+p.title+'<span class="sp">'+pr+'</span></a>';}).join('');
        }).catch(function(){res.innerHTML='<div class="none">Search unavailable.</div>';});
      },180);
    }
    if(btn)btn.addEventListener('click',open);
    if(cls)cls.addEventListener('click',close);
    if(mm)mm.addEventListener('click',function(e){e.preventDefault();var m=$('#mobileMenu');if(m)m.classList.remove('open');open();});
    ov.addEventListener('click',function(e){if(e.target===ov)close();});
    if(inp)inp.addEventListener('input',function(){render(inp.value);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  }

  /* ---------- CART drawer (Shopify AJAX) ---------- */
  function initCart(){
    var btn=$('#cartBtn'),ov=$('#cartOv'),panel=$('#cartPanel'),items=$('#cartItems'),count=$('#cartCount'),sub=$('#cartSub'),cls=$('#cartClose'),mm=$('#mmCart');
    if(!panel||panel.__c)return;panel.__c=1;
    function money(c){return '$'+(c/100).toFixed(2);}
    function open(){ov.classList.add('open');panel.classList.add('open');}
    function close(){ov.classList.remove('open');panel.classList.remove('open');}
    function draw(cart){
      var n=cart.item_count||0;$$('#cartCount, .nav__cartcount').forEach(function(c){c.textContent=n;});
      if(!cart.items||!cart.items.length){items.innerHTML='<p class="cart__empty">Your cart is empty.</p>';}
      else{items.innerHTML=cart.items.map(function(i,ix){
        return '<div class="citem"><img class="citem__img" src="'+(i.image||'')+'" alt=""><div class="citem__d"><div class="citem__n">'+i.product_title+(i.variant_title&&i.variant_title!=='Default Title'?(' — '+i.variant_title):'')+'</div><div class="citem__p">'+money(i.final_price)+'</div><button class="citem__rm" data-key="'+i.key+'">Remove</button></div><div class="citem__qty"><button data-dec="'+i.key+'">&minus;</button><span>'+i.quantity+'</span><button data-inc="'+i.key+'">+</button></div></div>';
      }).join('');}
      if(sub)sub.textContent=money(cart.total_price||0);
    }
    function refresh(){fetch('/cart.js').then(function(r){return r.json();}).then(draw);}
    function change(key,qty){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(draw);}
    window.n92AddToCart=function(id,qty,props,cb){
      if(typeof props==='function'){cb=props;props=null;}
      var item={id:id,quantity:qty||1};
      if(props&&Object.keys(props).length){item.properties=props;}
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[item]})})
      .then(function(r){return r.json();}).then(function(){refresh();open();if(cb)cb();})
      .catch(function(){if(cb)cb();});
    };
    if(btn)btn.addEventListener('click',function(){open();refresh();});
    if(cls)cls.addEventListener('click',close);
    if(ov)ov.addEventListener('click',function(e){if(e.target===ov)close();});
    if(mm)mm.addEventListener('click',function(e){e.preventDefault();var m=$('#mobileMenu');if(m)m.classList.remove('open');open();refresh();});
    items.addEventListener('click',function(e){var t=e.target;
      if(t.dataset.rm!=null||t.classList.contains('citem__rm')){change(t.getAttribute('data-key'),0);}
      else if(t.dataset.inc!=null){var el=items.querySelector('[data-inc]');change(t.getAttribute('data-inc'),null);}
    });
    // robust qty handling
    items.addEventListener('click',function(e){var t=e.target;
      var inc=t.getAttribute('data-inc'),dec=t.getAttribute('data-dec');
      if(inc){var span=t.parentElement.querySelector('span');change(inc,(+span.textContent)+1);}
      else if(dec){var span2=t.parentElement.querySelector('span');change(dec,Math.max(0,(+span2.textContent)-1));}
    });
    refresh();
  }

  /* ---------- add-to-cart buttons on product cards + PDP ---------- */
  function wireAddButtons(scope){
    scope=scope||document;
    $$('[data-add-id]',scope).forEach(function(b){if(b.__a)return;b.__a=1;
      b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();
        var id=b.getAttribute('data-add-id');if(!id)return;
        var orig=b.innerHTML;b.innerHTML='<span class="cart__spin"></span>';
        if(window.n92AddToCart)window.n92AddToCart(id,1,function(){b.innerHTML=orig;});
      });
    });
    // PDP add-to-cart form
    $$('[data-product-form]',scope).forEach(function(form){if(form.__af)return;form.__af=1;
      form.addEventListener('submit',function(e){e.preventDefault();
        var kind=form.getAttribute('data-pdp-kind')||'standard';
        var id=form.querySelector('[name="id"]').value;
        var qf=form.querySelector('#qVal');var qty=qf?(+qf.textContent):1;
        var props=null;
        if(kind==='bundle'){
          var wrap=form.querySelector('[data-bundle-flavors]');
          var need=1;var pb=form.querySelector('[data-pack-btn].active');
          if(pb){var m=(pb.getAttribute('data-value')||'').match(/\d+/);need=m?parseInt(m[0],10):1;}
          var rows=Array.prototype.slice.call(form.querySelectorAll('.flavrow'));
          var total=0;props={};var summary=[];
          rows.forEach(function(r){var n=+r.querySelector('[data-fval]').textContent;var name=r.getAttribute('data-flavor');
            total+=n;if(n>0){props[name]=n;summary.push(n+'× '+name);}});
          if(total!==need){ // not complete -> nudge, do not add
            var hint=wrap&&wrap.querySelector('[data-bundle-hint]');
            if(hint){hint.classList.add('err');setTimeout(function(){hint.classList.remove('err');},1600);}
            if(wrap)wrap.scrollIntoView({behavior:'smooth',block:'center'});
            return;
          }
          props['Flavors']=summary.join(', ');
          qty=1;
        }
        var btn=form.querySelector('[type="submit"]');var orig=btn?btn.innerHTML:'';if(btn)btn.innerHTML='<span class="cart__spin"></span>';
        if(window.n92AddToCart)window.n92AddToCart(id,qty,props,function(){if(btn)btn.innerHTML=orig;});
      });
    });
  }

  /* ---------- shop category filter ---------- */
  function wireShopFilter(scope){
    scope=scope||document;
    var filters=$('#shopFilters',scope);if(!filters||filters.__f)return;filters.__f=1;
    var grid=$('#shopGrid',scope);
    filters.addEventListener('click',function(e){var b=e.target.closest('.chip');if(!b)return;
      $$('.chip',filters).forEach(function(x){x.classList.remove('active');});b.classList.add('active');
      var cat=b.getAttribute('data-c');
      $$('.pcard',grid).forEach(function(card){
        var cc=card.getAttribute('data-cat')||'';
        card.style.display=(cat==='All'||cc===cat)?'':'none';
      });
    });
  }

  function initAll(scope){wireMenu(scope);initReveals(scope);initCounts(scope);initSun(scope);initParallax(scope);initFaq(scope);initPdp(scope);wireShopFilter(scope);wireAddButtons(scope);}
  document.addEventListener('DOMContentLoaded',function(){initSearch();initCart();initAll(document);});
  // editor-safe re-init
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);initSearch();initCart();});
  document.addEventListener('shopify:section:select',function(e){initReveals(e.target);});
  document.addEventListener('shopify:block:select',function(e){initReveals(e.target);});
  if(document.readyState!=='loading'){initSearch();initCart();initAll(document);}
})();
